(() => {
  function init(root) {
    if (root.dataset.wikiReady) return;
    root.dataset.wikiReady = 'true';
    const normalize = value => value.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
    const search = root.querySelector('[data-wiki-search]');
    const filters = [...root.querySelectorAll('[data-wiki-filter]')];
    const cards = [...root.querySelectorAll('[data-wiki-card]')].map(el => ({el, text: normalize(el.dataset.search), category: el.dataset.category}));
    let category = '';
    const update = () => {
      const terms = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
      let count = 0;
      cards.forEach(card => {
        const match = (!category || card.category === category) && terms.every(term => card.text.includes(term));
        card.el.hidden = !match;
        if (match) count++;
      });
      root.querySelector('[data-wiki-result]').textContent = `${count} ${count === 1 ? 'Eintrag' : 'Einträge'}${category ? ' · ' + category : ''}`;
      root.querySelector('[data-wiki-empty]').hidden = count !== 0;
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.wikiFilter === category)));
    };
    search.addEventListener('input', update);
    filters.forEach(button => button.addEventListener('click', () => {category = button.dataset.wikiFilter; update();}));
    root.querySelector('[data-wiki-reset]').addEventListener('click', () => {search.value = ''; category = ''; update(); search.focus();});
    root.querySelector('[data-wiki-controls]').hidden = false;
    update();
  }
  document.querySelectorAll('[data-wiki]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-wiki]').forEach(init));
})();
